import WalletSignUp from "./WalletSignUp";
export default WalletSignUp;
